import React, {useEffect, useState} from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useGetAllContactsQuery } from "../../state/api";
import Header from "components/Header";
import FlexBetween from "components/FlexBetween";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

const Contacts = () => {
    const theme = useTheme();
    const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
    const { data: contactsData, isLoading } = useGetAllContactsQuery();
    const contacts = contactsData?.contacts || [];
    const totalClients = contactsData?.total || 0;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [searchInput, setSearchInput] = useState("");
    const debouncedSearchInput = useDebounce(searchInput, 500);

    const filteredContacts = contacts.filter(contact =>
        contact.name.toLowerCase().includes(debouncedSearchInput.toLowerCase())
    );

    const columns = [
        {
        field: "id",
        headerName: "ID",
        minWidth: 50,
        flex: isMobile ? 0.2 : 0.3,
        },
        {
        field: "name",
        headerName: "Name",
        minWidth: 80,
        flex: isMobile ? 0 : 1.2,
        },
        {
        field: "company.name",
        headerName: "Company",
        minWidth: 0,
        flex: isMobile ? 0 : 1,
        valueGetter: (params) => params.row.company?.name || '',
        },
        {
        field: "mobile",
        headerName: "Mobile",
        minWidth: 80,
        flex: isMobile ? 0 : 1,
        },
        {
        field: "email",
        headerName: "Email",
        minWidth: 80,
        flex: isMobile ? 0 : 1.5,
        },
        {
        field: "tags",
        headerName: "Tags",
        minWidth: 50,
        flex: isMobile ? 0 : 0.6,
        }, 
    ];

    return (
        <Box m="1.5rem 2.5rem">
        <FlexBetween>
            <Header title="Clients" subtitle="Salesmate Contacts" />
            <Box>
            </Box>
        </FlexBetween>

        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"   
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            <Box
            height={750} 
            gridColumn="span 12"
            gridRow="span 3"
            sx={{
                "& .MuiDataGrid-root": {
                border: "none",
                borderRadius: "5rem",
                },
                "& .MuiDataGrid-cell": {
                borderBottom: "none",
                width: '100%',
                },
                "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[300],
                borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                backgroundColor: theme.palette.background.alt,
                },
                "& .MuiDataGrid-footerContainer": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderTop: "none",
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${theme.palette.secondary[200]} !important`,
                },
            }}
            >
            <DataGrid
                loading={isLoading || !contactsData}
                getRowId={(contact) => contact.id}
                rows={filteredContacts}
                columns={columns}
                rowCount={totalClients}
                components={{
                    Toolbar: () => (
                        <DataGridCustomToolbar
                        setSearchInput={setSearchInput}
                        />
                    ) 
                }}
            />
            
            </Box>
        </Box>
        </Box>
    );
};

export default Contacts;